import styled from '@emotion/styled';

const GrayButton = styled.button`
  margin-top: 3px;
  border-radius: 5px;
  text-transform: uppercase;
  background: #e4e4e4;
  border: 1px solid gray;
  font-size: 14px;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  i {
    margin: 0 6px 0 0;
  }

  &:hover {
    background: #f1f1f1;
  }

  &:disabled {
    color: gray;
  }
  
  &:disabled:hover {
    background: #e4e4e4;
  }
`;

export default GrayButton;